<template>
	<el-dialog :visible.sync="show"
		:title="$t('privateNetwork.openIpv6')"
		:close-on-click-modal="false"
		:before-close="handleClose"
		class="del-root">
      	<el-alert
		    :title="$t('privateNetwork.openPrivateNetworkIpv6Tip')"
		    :closable="false"
		    type="info"
			class="alert-tip">
	  	</el-alert>
		<p>{{ $t('privateNetwork.openPrivateNetworkIpv6Confirm', [vpcName]) }}</p>
		<div slot="footer" class="dialog-footer">
			<el-button @click="cancelDel">{{ $t('privateNetwork.cancel') }}</el-button>
			<el-button @click="sureDel" type="primary">{{ $t('privateNetwork.sure') }}</el-button>
		</div>
	</el-dialog>
</template>

<script>
export default {
	name: 'Ipv6Private',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		vpcName: {
			type: String,
			default: ''
		},
		vpcId: {
			type: String,
			default: ''
		},
		region: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			show: false
		};
	},
	watch: {
		visible(newVal) {
			this.show = newVal;
		}
	},
	methods: {
		handleClose() {
			this.show = false;
			this.$emit('update:visible', false);
		},
		cancelDel() {
			this.handleClose();
		},
		sureDel() {
			const params = {
				region: this.region,
				vpcId: this.vpcId,
				clientToken: Normal.getClientToken()
			};
			Ajax.post('/api/cps/vpcs/assignIpv6Cidr', params)
			.then((res) => {
				this.$emit('refresh');
			})
			.catch(async (err) => {
				const { response } = err.data;
				try {
					const json = await response.json();
					this.$message.error(json.errmsg);
				} catch(ex) {
					console.log(ex);
				}
			})
			.finally(() => {
				this.handleClose();
			});
		}
	},
};
</script>

<style lang="scss">
	@import "ipv6Private";
	.alert-tip {
		margin-bottom: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/components/privateNetwork/ipv6Private/ipv6Private.vue